<template>
  <div>
    <Loader
      v-show="loading"
      :loading="loading"
    />
    <v-card>
      <v-card-title>
        <v-row no-gutters>
          <span class="headline font-weight-medium">{{ header }}</span>
          <v-spacer />
          <IconBtn
            icons="close"
            :large="true"
            color="grey darken-4"
            @click="close"
          />
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <CustomTextField
              v-model="title"
              label="Найменування"
              :hide-details="true"
              :required="true"
              :error-messages="$v.title.$invalid ? errors.TITLE : []"
              @input="isChanged = true"
            />
          </v-col>
          <v-col>
            <CustomTextField
              v-model="fullTitle"
              label="Повне найменування"
              :hide-details="true"
              @input="isChanged = true"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <CustomTextField
              v-model="siteTitle"
              label="Найменування для сайту"
              :hide-details="true"
              @input="isChanged = true"
            />
          </v-col>
          <v-col>
            <UnitSelect
              v-model="unit"
              label="Одиниці виміру"
              @input="isChanged = true"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <label
              for="files"
              class="primary-button v-btn v-btn--contained theme--light v-size--default"
            > Додати зображення</label>
            <input
              id="files"
              style="visibility:hidden; position: absolute; width: 24px; height: 24px"
              type="file"
              title="Зображення"
              multiple
              accept="image/*"
              @input="addPicture"
            >
          </v-col>
        </v-row>
        <ProductPicture
          :product-pictures="pictures"
          :is-new="isNew"
          @delete="deletePicture"
        />
      </v-card-text>
      <v-card-actions>
        <PrimaryBtn
          :loading="loading"
          :disabled="!isChanged || isFormInvalid"
          @click="save"
        />
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import * as productsApi from "../../backend/productsApi.js";
import Loader from "../../../components/Loader.vue";
import IconBtn from "../../../components/IconBtn.vue";
import PrimaryBtn from "../../../components/PrimaryBtn.vue";
import CustomTextField from "../../../components/CustomTextField.vue";
import { ERRORS } from "@/helpers";
import { required } from "vuelidate/lib/validators";
import UnitSelect from "../units/UnitsSelect.vue";
import ProductPicture from "./ProductPicture.vue";
import upload from "../../helpers/uploadImage.js";

export default {
  components: {
    Loader,
    IconBtn,
    PrimaryBtn,
    CustomTextField,
    UnitSelect,
    ProductPicture,
  },
  props: ["id"],
  data: () => ({
    loading: false,
    isChanged: false,
    title: "",
    fullTitle: "",
    siteTitle: "",
    unit: null,
    productPictures: [],
    files: null,
  }),
  validations: {
    title: {
      required,
    },
  },
  computed: {
    isFormInvalid() {
      return this.$v.title.$invalid;
    },

    isNew() {
      return this.id != 0 ? false : true;
    },
    header() {
      return this.isNew ? "Створення товару" : "Редагування товару";
    },
    errors() {
      return {
        TITLE: [ERRORS.REQUIRED],
      };
    },
    pictures(){
      return this.productPictures;
    },
  },
  created() {
    if (this.id != 0) {
      productsApi.getProduct(this.id).then((entity) => {
        this.id = entity.id;
        this.title = entity.title;
        this.fullTitle = entity.fullTitle;
        this.siteTitle = entity.siteTitle;
        this.unit = entity.unit;
        this.productPictures = entity.pictures.map(x => {
          return {
            id: x.id,
            name: x.fileName,
            data: `data:image/jpeg;base64, ${x.data}`,
          };
        });
      });
    }
  },
  methods: {
    async addPicture(event){
      if (!this.isNew){
        const formData = upload(event);
        await productsApi.uploadImages(this.id, formData);

        location.reload();
      } else {
        this.files = event;
        this.productPictures = [];

        for (let index = 0; index < event.target.files.length; index++) {
          const element = event.target.files[index];
          const file = {
            id: this.createGuid(),
            name: element.name,
            data: URL.createObjectURL(element),
          };
          this.productPictures.push(file);
        }
      }
    },
    async save() {
      this.loading = true;

      const newEntity = {
        title: this.title,
        fullTitle: this.fullTitle,
        siteTitle: this.siteTitle,
        unitId: this.unit ? this.unit.id : null,
      };

      if (this.id == 0) {
        await productsApi.createProduct(newEntity).then(async(response) => {
          const productId = response.data;
          if (this.files){
            const formData = upload(this.files);
            await productsApi.uploadImages(productId, formData);
          }

          this.$router.push({ path: "/sales-products" });
        });
      } else {
        await productsApi.updateProduct(this.id, newEntity);
        this.$notifySuccess();
      }
      this.loading = false;
    },
    async deletePicture(picture){
      await productsApi.deleteProductPicture(this.id, picture.id).then(()=>{
        this.productPictures = this.productPictures.filter((item) => {
          return item.id != picture.id;
        });
      });
    },
    close() {
      if (this.modal) {
        this.$emit("close");
      } else {
        this.$router.go(-1);
      }
    },
    createGuid()
    {
      return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );
    },
  },
};
</script>